import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate } from 'react-router-dom'

import {
  resetShortlists,
  startSavingShortlistState,
} from '@disco/state-management/actions/ShortlistActions'

import DocumentHeadTags from 'components/document-head-tags'
import ModalDialog from 'components/ui/modal-dialog'

const mapDispatchToProps = {
  resetShortlists,
  startSavingShortlistState,
}

const connector = connect(null, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

type Props = PropsFromRedux & {
  navigate: NavigateFunction
}

class ShortlistsClear extends React.Component<Props> {
  _onClose = () => {
    this.props.navigate('/')
  }
  _handleClear = () => {
    this.props.resetShortlists()
    this.props.startSavingShortlistState()

    this._onClose()
  }

  render() {
    return (
      <div>
        <DocumentHeadTags title="Clear playlist creator | DISCO" />
        <ModalDialog
          title="Clear playlist creator"
          primaryAction={{
            caption: 'Clear',
            onClick: this._handleClear,
          }}
          status="danger"
          onCancel={this._onClose}
        >
          Are you sure you want to clear the Playlist Creator? This can’t be
          undone.
        </ModalDialog>
      </div>
    )
  }
}

const ConnectedShortlistsClear = connector(ShortlistsClear)

function ShortlistsClearWithNavigate(props) {
  const navigate = useNavigate()
  return <ConnectedShortlistsClear {...props} navigate={navigate} />
}

export default ShortlistsClearWithNavigate
